import React from "react";
import { InstagramLogin } from '@amraneze/react-instagram-login';

const LogoutButton = () => {

  const responseInstagram = (response) => {
    console.log(response);
  };

  return (
    <div className="App">
      <h2>Login with Instagram</h2>

      <InstagramLogin
        clientId="2668915413294892"  
        buttonText="Login with Instagram" 
        scope="basic" 
        onSuccess={responseInstagram} 
        onFailure={responseInstagram} 
      />
    </div>
  );
};

export default LogoutButton;

// import React from "react";
// import { InstagramLogin } from '@amraneze/react-instagram-login';

// const LogoutButton = () => {

//   const responseInstagram = (response) => {
//     console.log(response);
//   };

//   return (
//     <div className="App">
//       <h2>Login with Instagram</h2>

//       <InstagramLogin
//         clientId="2668915413294892"  
//         buttonText="Login with Instagram" 
//         scope="basic" 
//         onSuccess={responseInstagram} 
//         onFailure={responseInstagram} 
//       />
//     </div>
//   );
// };

// export default LogoutButton;



// import React, { useEffect, useState } from 'react';

// const LogoutButton = () => {
//   const [user, setUser] = useState(null);

//   // Initialize Facebook SDK
//   const initFacebookSDK = () => {
//     if (window.FB) {
//       window.FB.init({
//         appId: '996463539016492', // Your Facebook App ID
//         autoLogAppEvents: true,
//         xfbml: true,
//         version: 'v16.0', // Or the latest Facebook Graph API version
//       });
//     } else {
//       console.error('Facebook SDK is not loaded');
//     }
//   };

//   useEffect(() => {
//     // Dynamically load the Facebook SDK script if not already loaded
//     if (!window.FB) {
//       // Load the SDK script
//       const script = document.createElement('script');
//       script.src = 'https://connect.facebook.net/en_US/sdk.js';
//       script.async = true;
//       script.defer = true;
//       script.onload = () => {
//         // Initialize the SDK after the script is loaded
//         window.fbAsyncInit = initFacebookSDK;
//       };
//       document.body.appendChild(script);
//     } else {
//       // If the SDK is already loaded, just initialize it
//       initFacebookSDK();
//     }
//   }, []);

//   const handleFacebookLogin = () => {
//     if (window.FB) {
//       window.FB.login(
//         (response) => {
//           if (response.authResponse) {
//             window.FB.api('/me?fields=name,email,picture', (userInfo) => {
//               setUser({
//                 name: userInfo.name,
//                 email: userInfo.email,
//                 picture: userInfo.picture.data.url,
//               });
//             });
//           } else {
//             console.log('User login failed');
//           }
//         },
//         { scope: 'public_profile,email' }
//       );
//     } else {
//       console.error('Facebook SDK is not initialized');
//     }
//   };


//   const handleFacebookLogout = () => {
//     if (window.FB) {
//       window.FB.logout((response) => {
//         setUser(null);
//       });
//     } else {
//       console.error('Facebook SDK is not initialized');
//     }
//   };

//   return (
//     <div>
//       {user ? (
//         <div>
//           <h3>Welcome, {user.name}</h3>
//           <img src={user.picture} alt="Profile" />
//           <p>{user.email}</p>
//           <button onClick={handleFacebookLogout}>Logout</button>
//         </div>
//       ) : (
//         <button onClick={handleFacebookLogin}>Login with Facebook</button>
//       )}
//     </div>
//   );
// };

// export default LogoutButton;



// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { logoutUser } from "../redux/slice/authSlice/UserSlice.js";

// const LogoutButton = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handleLogout = async () => {
//     const token = localStorage.getItem("userToken");
//     if (token) {
//       await dispatch(logoutUser());
//       console.log("User logged out successfully.");

//       navigate("/login");
//     } else {
//       console.log("No token found, user is not logged in.");
//       navigate("/login");
//     }
//   };

//   return <button onClick={handleLogout}>Logout</button>;
// };

// export default LogoutButton;


